import hatsApi from '@/services/hatsApi'

export default {
  getSeasons (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/season/?filter=' + JSON.stringify(filter))
  },
  createSeason (params) {
    return hatsApi().post('/master-data/season', params)
  },
  updateSeason (params) {
    return hatsApi().put('/master-data/season/' + params.id, params)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Season.js